import * as Yup from "yup";
import formFieldCamiseta from "./formFieldKits";

const { id, tamanho, quantidade, eventId } = formFieldCamiseta;

const validationCamiseta = Yup.object().shape({
  [id.name]: Yup.string().optional(),
  [tamanho.name]: Yup.string().required(tamanho.errorMsg),
  [quantidade.name]: Yup.string().required(quantidade.errorMsg),
  [eventId.name]: Yup.string().required(eventId.errorMsg),
});

export { validationCamiseta };
